import React from 'react'
import { useLinkYourBoard } from './LinkYourBoard.hook'
import { QuizQuestionWrapper } from '../../components'
import { useLocation } from 'react-router-dom'
import { QuizType } from 'src/pages/shared'
import '../style.scss'
import pinterestLogo from 'src/assets/images/Pinterest-Badge-White.webp'

export const LinkYourBoard = () => {
  const query = new URLSearchParams(useLocation().search)
  const { handleNext, handleBack, handlePinterestOauth } = useLinkYourBoard()

  return (
    <>
      <QuizQuestionWrapper
        titleStep="Getting Started"
        title="We want to see your vision"
        subtitle="Link your Pinterest board to inspire your proposal, or choose a color palette to start from scratch"
        backAction={{
          onAction: handleBack,
        }}
        nextAction={{
          onAction: handleNext,
        }}
        step={2}
        total={7}
        className="pinterest-flow link-your-board-page request-a-proposal mobile-availability"
        quizType={query.get('quizType') as QuizType}
      >
        <div className="request-a-proposal-wrapper link-your-board-page">
          <div className="button-group">
            <button className="button pinterest-button" onClick={handlePinterestOauth}>
              <img src={pinterestLogo} alt="Pinterest" className="pinterest-logo" />
              Connect with Pinterest
            </button>
            <span className="eyebrow">OR</span>
            <button className="button secondary" onClick={handleNext}>
              Choose color palette
            </button>
          </div>
        </div>
      </QuizQuestionWrapper>
    </>
  )
}
